<ef-loading-container
    [observables]="[accountAllocations$, expenseType$, costCenters$]"
></ef-loading-container>
<ef-cost-allocation
    [items]="accountAllocations$ | async"
    [expenseTypes]="expenseType$ | async"
    [costCenters]="costCenters$ | async"
    [selectedError]="selectedError"
    (ShowError)="ShowError.next($event)"
    (SaveItem)="onSaveCostAllocation($event)"
></ef-cost-allocation>
